import React from 'react';
import {
  ChatRequestModalOverlay,
  ChatRequestModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestModalButtons,
  ChatRequestModalButton,
  TrustPeerModalDescription,
  TrustPeerOptionsContainer,
  TrustPeerOptionItem,
  TrustPeerOptionRow,
  TrustPeerCheckbox,
  TrustPeerOptionLabel,
  TrustPeerOptionDescription,
} from '../../../styles/UserWorkspacePageStyles';
import { useT } from '../../../LocaleContext';

const TrustPeerModal = ({
  isOpen,
  onClose,
  chatToTrust,
  trustSettings,
  onTrustSettingChange,
  onSelectAllTrust,
  onSaveTrustSettings,
}) => {
  const t = useT();

  if (!isOpen || !chatToTrust) return null;

  return (
    <ChatRequestModalOverlay onClick={onClose}>
      <ChatRequestModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <ChatRequestModalTitle>{t('modals.trustPeer')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <div style={{ marginBottom: '10px' }}>
          <TrustPeerModalDescription>
            enable trust for <strong>{chatToTrust.peer_name}</strong>:
          </TrustPeerModalDescription>
          <TrustPeerOptionsContainer>
            {/* Select All */}
            <TrustPeerOptionItem
              isSelected={trustSettings.shareAvatar && trustSettings.shareEmail && trustSettings.shareStatus}
              onClick={onSelectAllTrust}
            >
              <TrustPeerOptionRow>
                <TrustPeerCheckbox
                  checked={trustSettings.shareAvatar && trustSettings.shareEmail && trustSettings.shareStatus}
                  onChange={onSelectAllTrust}
                />
                <TrustPeerOptionLabel>{t('modals.selectAll')}</TrustPeerOptionLabel>
              </TrustPeerOptionRow>
            </TrustPeerOptionItem>
            
            {/* Share Avatar */}
            <TrustPeerOptionItem
              isSelected={trustSettings.shareAvatar}
              onClick={() => onTrustSettingChange('shareAvatar')}
            >
              <TrustPeerOptionRow hasDescription>
                <TrustPeerCheckbox
                  checked={trustSettings.shareAvatar}
                  onChange={() => onTrustSettingChange('shareAvatar')}
                />
                <TrustPeerOptionLabel>{t('modals.shareAvatar')}</TrustPeerOptionLabel>
              </TrustPeerOptionRow>
              <TrustPeerOptionDescription>
                {t('modals.shareAvatarDesc')}
              </TrustPeerOptionDescription>
            </TrustPeerOptionItem>
            
            {/* Share Email */}
            <TrustPeerOptionItem
              isSelected={trustSettings.shareEmail}
              onClick={() => onTrustSettingChange('shareEmail')}
            >
              <TrustPeerOptionRow hasDescription>
                <TrustPeerCheckbox
                  checked={trustSettings.shareEmail}
                  onChange={() => onTrustSettingChange('shareEmail')}
                />
                <TrustPeerOptionLabel>{t('modals.shareEmail')}</TrustPeerOptionLabel>
              </TrustPeerOptionRow>
              <TrustPeerOptionDescription>
                {t('modals.shareEmailDesc')}
              </TrustPeerOptionDescription>
            </TrustPeerOptionItem>
            
            {/* Share Status */}
            <TrustPeerOptionItem
              isSelected={trustSettings.shareStatus}
              onClick={() => onTrustSettingChange('shareStatus')}
            >
              <TrustPeerOptionRow hasDescription>
                <TrustPeerCheckbox
                  checked={trustSettings.shareStatus}
                  onChange={() => onTrustSettingChange('shareStatus')}
                />
                <TrustPeerOptionLabel>{t('modals.shareStatus')}</TrustPeerOptionLabel>
              </TrustPeerOptionRow>
              <TrustPeerOptionDescription>
                {t('modals.shareStatusDesc')}
              </TrustPeerOptionDescription>
            </TrustPeerOptionItem>
          </TrustPeerOptionsContainer>
        </div>
        <ChatRequestModalButtons>
          <ChatRequestModalButton onClick={onClose}>
            {t('common.cancel')}
          </ChatRequestModalButton>
          <ChatRequestModalButton 
            onClick={onSaveTrustSettings}
            primary
          >
            {t('common.ok')}
          </ChatRequestModalButton>
        </ChatRequestModalButtons>
      </ChatRequestModalContent>
    </ChatRequestModalOverlay>
  );
};

export default TrustPeerModal;
